import React, { Component } from 'react';
import { ReactComponent as DarkSun } from '../../images/dark-sun.svg';

// import SeleniumDebugable from '../ribbons/seleniumDebugable';

class PageSpinner extends Component {
  render() {
    return (
      <div className="proposal-page">
        <div className="content">
          <div className="load-spin">
            <DarkSun className="dark-sun-icon icon" title="loading-spinner" /> Loading
          </div>
        </div>
      </div>
    );
  }
}

export default PageSpinner;
